import { createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api';
import type { ServiceRequest } from '../../types/shared';

// Fetch all service requests
export const fetchRequests = createAsyncThunk(
  'requests/fetchAll',
  async (filters?: { status?: string; category?: string }) => {
    const requests = await apiService.getServiceRequests(filters);
    return requests;
  }
);

// Fetch single service request
export const fetchRequestById = createAsyncThunk('requests/fetchById', async (id: string) => {
  const request = await apiService.getServiceRequest(id);
  if (!request) {
    throw new Error('Service request not found');
  }
  return request;
});

// Create new service request
export const createRequest = createAsyncThunk(
  'requests/create',
  async (data: {
    title: string;
    description: string;
    category: ServiceRequest['category'];
    priority?: ServiceRequest['priority'];
    location?: string;
    unit?: string;
    images?: string[];
  }) => {
    const request = await apiService.createServiceRequest(data);
    if (!request) {
      throw new Error('Failed to create service request');
    }
    return request;
  }
);

// Update service request
export const updateRequest = createAsyncThunk(
  'requests/update',
  async ({ id, data }: { id: string; data: Partial<ServiceRequest> }) => {
    const request = await apiService.updateServiceRequest(id, data);
    if (!request) {
      throw new Error('Failed to update service request');
    }
    return request;
  }
);

// Delete service request
export const deleteRequest = createAsyncThunk('requests/delete', async (id: string) => {
  const success = await apiService.deleteServiceRequest(id);
  if (!success) {
    throw new Error('Failed to delete service request');
  }
  return id;
});
